import ReactHtmlParser from 'react-html-parser'

export function toHtml(str) {
    const beginTagRegex = /<([\w-]+)>/g
    const endTagRegex = /<\/>/g
    const beginTagSubst = '<span class="$1">'
    const endTagSubst = '</span>'
    const beginTagCount = (str.match(beginTagRegex) || []).length

    if (beginTagCount === 0) return str

    const endTagCount = (str.match(endTagRegex) || []).length

    let result = str.replace(beginTagRegex, beginTagSubst).replace(endTagRegex, endTagSubst)

    // Add missing end-tags
    for (let i = beginTagCount - endTagCount; i > 0; i--) {
        result += endTagSubst
    }

    return `<span>${result}</span>`
}

export function toReact(str) {
    return ReactHtmlParser(toHtml(str))
}
